import { Button, Stack, Group, Chip, Title, Text, Space, Anchor, ScrollArea, SimpleGrid } from '@mantine/core';
import { LoginWrapper } from '../LoginWrapper';
import { MobileLogo } from './SignUpEmail';
import { ProgressBar } from './Components/ProgressBar';
import { primaryColor } from '../../constants/theme';
import { CATEGORIES } from '../../constants/options';
import { useEffect, useState } from 'react';
import { IconCheck } from '@tabler/icons-react';
import { useOnboarding } from './SignUpContext';
import { CategoryResponseModel } from '../../types/Profile';
import { useNavigate } from 'react-router-dom';
import { PageRoutes } from '../../constants/routes';

export const CategorySelection = () => {

    const {form} = useOnboarding();
    const navigate = useNavigate();
    const [selectedOptions, setSelectedOptions] = useState<CategoryResponseModel[]>([]);

    const onSelect = (category: CategoryResponseModel) => {
    if(selectedOptions.some(item => item.id === category.id && item.name === category.name)) {
            setSelectedOptions(selectedOptions.filter((item) => item.id !== category.id || item.name !== category.name));
        } else {
            setSelectedOptions([...selectedOptions, category]);
        }
    }

    useEffect(() => {
        form.setFieldValue('categories', selectedOptions);
    }, [selectedOptions]);

    return (
        <LoginWrapper animate={false}>
            <MobileLogo />
            <Stack>
                <Group justify='space-between'>
                    <Title data-test-id={CategoryTestIds.CATEGORY_TITLE} order={2}>{CategoriesText.TITLE}</Title>
                    <Text><Anchor data-test-id={CategoryTestIds.CATEGORY_SKIP_BUTTON} c='dimmed'>{CategoriesText.SKIP_BUTTON}</Anchor></Text>
                </Group>
                <Text ta='left' data-test-id={CategoryTestIds.CATEGORY_SUBTITLE}>{CategoriesText.SUBTITLE}</Text>
                <ScrollArea h='55vh'>
                    <Stack align='center'>
                        <Chip.Group multiple>
                            <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" verticalSpacing="md">
                                {CATEGORIES.map((category) => (
                                    <CategoryOption key={category.id} category={category} selectedOptions={selectedOptions} selectedOption={onSelect} />
                                ))}
                            </SimpleGrid>
                        </Chip.Group>
                        <Space h='sm'></Space>
                    </Stack>
                </ScrollArea>
                <Button fullWidth radius={'lg'} size={'md'}  color={primaryColor} data-test-id={CategoryTestIds.CATEGORY_NEXT_BUTTON} onClick={() => navigate(PageRoutes.ONBOARDING_SEARCH_TERMS)}>{CategoriesText.NEXT_BUTTON}</Button>
            </Stack>
            <Space h={{ base: 'md', sm: 'xl' }}></Space>
            <ProgressBar step={2} total={3} textTestId={CategoryTestIds.CATEGORY_PROGRESS_TEXT} progressTestId={CategoryTestIds.CATEGORY_PROGRESS_BAR}></ProgressBar>
        </LoginWrapper>

    )
}

export const CategoryOption = ({ category, selectedOptions, selectedOption }: {category: CategoryResponseModel, selectedOptions: CategoryResponseModel[], selectedOption: (option: CategoryResponseModel) => void}) => {

    const isSelected = selectedOptions.some(item => item.id === category.id && item.name === category.name);

    return (
        <Button data-testid={CategoryTestIds.CATEGORY_OPTION} leftSection={isSelected ? <IconCheck /> : null} fullWidth variant={isSelected ? 'filled' : 'outline'} color={isSelected ? primaryColor : 'black'}  onClick={() => selectedOption(category)}>{category.name}</Button>
    )
}


export enum CategoryTestIds {
    CATEGORY_OPTION = 'category-option',
    CATEGORY_TITLE = 'category-title',
    CATEGORY_SUBTITLE = 'category-subtitle',
    CATEGORY_NEXT_BUTTON = 'category-next-button',
    CATEGORY_SKIP_BUTTON = 'category-skip-button',
    CATEGORY_PROGRESS_BAR = 'category-progress-bar',
    CATEGORY_PROGRESS_TEXT = 'category-progress-text'
}

export enum CategoriesText {
    TITLE = 'Categories',
    SUBTITLE = 'Please select categories that you specialise in',
    NEXT_BUTTON = 'NEXT',
    SKIP_BUTTON = 'Skip'
}